import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function FacebookIcon({ link, style, className }) {
  if (logComponent('FacebookIcon')) { console.debug('FacebookIcon rendered'); }

  return  (
    <a href={link} className={className} title="Facebook" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon style={style} icon={['fab','facebook']} />
    </a>
  )
}